import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './css/CarouselBanner.css';

import nvvr from '../img/pic/viber_image_2025-09-18_10-42-29-806.jpg';
import nvvr1 from '../img/pic/viber_image_2025-09-18_10-42-32-213.jpg';
import nvvr2 from '../img/pic/viber_image_2025-09-18_10-42-33-268.jpg';
import nvvr3 from '../img/pic/viber_image_2025-09-18_10-42-33-784.jpg';
import nvvr4 from '../img/pic/viber_image_2025-09-18_10-42-34-111.jpg';
import nvvr5 from '../img/pic/viber_image_2025-09-18_10-42-34-443.jpg';
import nvvr6 from '../img/pic/viber_image_2025-09-18_10-42-35-098.jpg';
import nvvr7 from '../img/pic/viber_image_2025-09-18_10-42-35-515.jpg';
import nvvr8 from '../img/pic/viber_image_2025-09-18_10-42-36-067.jpg';

const slides = [nvvr, nvvr1, nvvr2, nvvr3, nvvr4, nvvr5, nvvr6, nvvr7, nvvr8];

const CustomArrow = ({ direction, onClick }: { direction: 'left' | 'right', onClick: () => void }) => (
    <button
        onClick={onClick}
        className={`custom-arrow ${direction}-arrow`}
        aria-label={direction === 'left' ? 'Previous slide' : 'Next slide'}
    >
        <span className="arrow-icon">{direction === 'left' ? '<' : '>'}</span>
    </button>
);

const CarouselBanner: React.FC = () => {
    return (
        <div className="carousel-wrapper">
            <Carousel
                autoPlay
                infiniteLoop
                showThumbs={false}
                showStatus={false}
                showIndicators={true}
                interval={5000}
                swipeable
                emulateTouch
                stopOnHover={false}
                dynamicHeight={true}
                transitionTime={500}
                renderArrowPrev={(onClickHandler, hasPrev) =>
                    hasPrev && <CustomArrow direction="left" onClick={onClickHandler} />
                }
                renderArrowNext={(onClickHandler, hasNext) =>
                    hasNext && <CustomArrow direction="right" onClick={onClickHandler} />
                }
            >
                {slides.map((src, index) => (
                    <div key={index} className="carousel-slide">
                        <img src={src} alt={`Slide ${index + 1}`} className="carousel-image" />
                    </div>
                ))}
            </Carousel>
        </div>
    );
};

export default CarouselBanner;